/** Converter for converting Paytronix customer to SDK Customer. */
export class CustomerConverter {
  static CUSTOMER_MAP = new Map([
    ['firstname', 'givenName'],
    ['lastname', 'familyName'],
    ['phone', 'phoneNumber'],
    ['dateofbirth', 'birthday'],
    ['email', 'emailAddress'],
    ['printedcardnumber', 'referenceId'],
  ]);

  static ADDRESS_MAP = new Map([['postalcode', 'postalCode']]);

  static convert(headerFields, rowFields) {
    const customer = {
      address: {},
    };

    for (let i = 0; i < headerFields.length; i++) {
      if (CustomerConverter.CUSTOMER_MAP.has(headerFields[i])) {
        customer[CustomerConverter.CUSTOMER_MAP.get(headerFields[i])] =
          rowFields[i];
      } else if (CustomerConverter.ADDRESS_MAP.has(headerFields[i])) {
        customer.address[CustomerConverter.ADDRESS_MAP.get(headerFields[i])] =
          rowFields[i];
      }
    }

    return customer;
  }
}
